// From http://stackoverflow.com/a/384380/4085004
// Returns true if it is a DOM element
export default function isElement(o) {
	return (
		typeof HTMLElement === 'object' ?
			o instanceof HTMLElement : // DOM2
			o && typeof o === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string'
	);
}



// WEBPACK FOOTER //
// ./assets/scripts/is-element.js